var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2554 13.4148C13.5534 13.4148 12.9206 13.6872 12.4403 14.126L5.85895 10.2881C5.90974 10.0802 5.94209 9.86318 5.94209 9.64149C5.94209 9.4198 5.90974 9.20275 5.85895 8.99492L12.371 5.19389C12.8652 5.65575 13.5257 5.94208 14.2554 5.94208C15.7841 5.94208 17.0265 4.69973 17.0265 3.17099C17.0265 1.64226 15.7841 0.399902 14.2554 0.399902C12.7266 0.399902 11.4843 1.64226 11.4843 3.17099C11.4843 3.39268 11.5166 3.60973 11.5674 3.81757L5.05534 7.61855C4.56117 7.15669 3.9007 6.87036 3.17099 6.87036C1.64226 6.87036 0.399902 8.11271 0.399902 9.64145C0.399902 11.1702 1.64226 12.4125 3.17099 12.4125C3.9007 12.4125 4.56117 12.1262 5.05534 11.6643L11.6367 15.5023C11.5905 15.6963 11.5628 15.8995 11.5628 16.1073C11.5628 17.5945 12.7682 18.7999 14.2554 18.7999C15.7425 18.7999 16.948 17.5945 16.948 16.1073C16.948 14.6201 15.7425 13.4148 14.2554 13.4148Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.cd41ce2e1c1b88f3438f4c5192cd7c0e.svg";
export { ForwardRef as ReactComponent };